import { api } from 'src/api/axios';

export const useDeleteStaff = (id: number | string) => api.delete(`/api/cms/admin/${id}`);
